import { useContext } from "react";
import { UppyContext } from "./UppyContext";

export function useUppyContext() {
  const context = useContext(UppyContext);
  if (!context) {
    throw new Error("useUppyContext must be used within UppyProvider");
  }
  return context;
}

